<div class="container cover nicetoknow">
    <div class="row terms-text">
        <div class="col-sm-12" [innerHTML]="contex?.content | safehtml"></div>
    </div>
</div>
